// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\na.link[data-v-106ac17c] {\n  color: #006c27;\n  background-color: transparent;\n  text-decoration: none;\n  cursor: pointer !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
